module.exports = __webpack_public_path__ + "static/media/TZ.144c3c80.svg";